import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize } from '../../util/Localizer'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import Paper from '@material-ui/core/Paper'
import Card from '@material-ui/core/Card'
import QuestionLink from '../../controls/QuestionLink'
import Icon from '@material-ui/core/Icon'
import { clearPeriodTotals } from '../../redux/actions/submitExpenseActions'
import Config from '../../Config'

const hcsaClaim = 'hcsaClaim'
const newClaim = 'newClaim'

class ClaimType extends Component {
  constructor () {
    super()
    this.chooseClaimType = this.chooseClaimType.bind(this)
    this.updateClaim = this.updateClaim.bind(this)
    this.updateNext = this.updateNext.bind(this)
    this.state = {
      type: null
    }
  }

  componentDidMount () {
    this.props.updateUrl(null)
    this.props.setNext(null)
    this.props.setPercent(30)
    this.props.adjustScrollBar()

    var event = document.createEvent('Event')
    event.initEvent('resize', true, true)
    window.addEventListener('resize', function (e) {
    }, false)
    window.dispatchEvent(event)
  }

  chooseClaimType (claimType) {
    if (this.props.memberSummary.isHCSAAvailable === false && claimType === hcsaClaim) { // REMOVE LATER
      window.alert('TODO: SELECT FUNCTIONALITY. This user does not have a HCSA, please test with a user who does. Example users inlcude 10026/password, RANTHONY/password, and MAKYIAAS/password, 10009/password etc')
    } else {
      this.props.clearPeriodTotals()
      this.setState({ type: claimType }, () => this.updateNext())
      this.updateClaim(claimType)
    }
  }

  updateClaim (claimType) {
    const claimObj = { ...this.props.claimObj }
    claimObj.claimType = claimType
    // Update Claim Object
    this.props.updateClaim(claimObj)
  }

  updateNext () {
    if (this.state.type === newClaim) {
      this.props.setNext('claimTypeBenefit')
    } else if (this.state.type === hcsaClaim) {
      this.props.setNext('expense')
    } else {
      this.props.setNext(null)
    }
  }

  renderHscaContent () {
    const hscaContentKeys = ['point1', 'point2', 'point3', 'point4']
    const hscaContentItems = hscaContentKeys.reduce((items, key) => {
      const line = localize(`common.hcsa.content.${key}`)
      if (line) {
        const item = <li>{line}</li>
        return [ ...items, item ]
      } else {
        return items
      }
    }, [])

    return (
      <div>
        <p>{localize('common.hcsa.content')}</p>
        <ul>{hscaContentItems}</ul>
      </ div>
    )
  }

  render () {
    const shouldRenderHcsa = (!Config.member.hcsa.hideClaimsSubmission && this.props.memberSummary.isHCSAAvailable)

    return (
      <Card className='submitCard'>
        <Row start='xs'>
          <Col xs={12}>
            <h3>{localize('pages.SubmitAClaim.NewClaim.Title')}</h3>
          </Col>
        </Row>
        <br />
        <Col xs={12}>
          <Row center='xs' middle='xs'>
            <Col xs={12} sm={10} md={5} lg={4}>
              <Paper className={this.state.type === newClaim ? 'claimTypeSelected' : 'claimTypeUnSelect'} onClick={() => this.chooseClaimType(newClaim)} elevation={this.state.type === newClaim ? 3 : 1}>
                <Row center='xs' middle='xs' style={{ height: 300 }}>
                  <Col>
                    <Icon style={{ fontSize: 67 }} className={this.state.type === newClaim ? 'claimTypeSelectIcon' : 'claimTypeSelectedIcon'}>add_circle</Icon>
                    <h4>{localize('pages.SubmitAClaim.NewClaim.SubmitNewClaimButton')}</h4>
                  </Col>
                </Row>
              </Paper>
            </Col>
            {shouldRenderHcsa &&
              <Col xs={12} sm={10} md={2} lg={2}>
                <p>{localize('pages.SubmitAClaim.NewClaim.Or')}</p>
              </Col>
            }
            {shouldRenderHcsa &&
              <Col xs={12} sm={10} md={5} lg={4}>
                <Paper className={this.state.type === hcsaClaim ? 'claimTypeSelected' : 'claimTypeUnSelect'} onClick={() => this.chooseClaimType(hcsaClaim)} elevation={this.state.type === hcsaClaim ? 3 : 1}>
                  <Row center='xs' middle='xs' style={{ height: 300 }}>
                    <Col>
                      <Icon style={{ fontSize: 67 }} className={this.state.type === newClaim ? 'claimTypeSelectIcon' : 'claimTypeSelectedIcon'}>monetization_on</Icon>
                      <h4>{localize('pages.SubmitAClaim.NewClaim.PayingUsingHealthCareSpendingAccountButton')}</h4>
                    </Col>
                  </Row>
                </Paper>
              </Col>
            }
          </Row>
          <br/>
          {shouldRenderHcsa &&
            <Row center='xs' middle='xs'>
              <Col xs={12} sm={10} md={5} lg={4}></Col>
              <Col xs={12} sm={10} md={2} lg={2}></Col>
              <Col xs={12} sm={10} md={5} lg={4}>
                <QuestionLink
                  title={localize('common.hcsa.whatIsHcsa')}
                  content={this.renderHscaContent()}
                />
              </Col>
            </Row>}
          <br />
        </Col>
      </Card>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    claimObj: state.SubmitAClaimReducer.claimObj,
    error: state.SubmitAClaimReducer.error,
    memberSummary: state.memberSummaryReducer.memberSummary
  }
}
const ConnectedClaimType = connect(mapStateToProps, { clearPeriodTotals })(injectIntl(ClaimType))
export default ConnectedClaimType



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/ClaimTypeSelect.js